import React from "react";
import { Reveal, Stagger, StaggerItem } from "../../lib/motion";
import { ArrowUpRight } from "lucide-react";
import { useApp } from "@/context/AppContext";

const projects = [
  { url: "loveexclusivephotography.co.uk", labelKey: null, label: "Luxury photography", vimeoId: "1184807765" },
  { url: "soundmoo.com", labelKey: null, label: "Sound platform", vimeoId: "1184806860" },
  { url: "loveexclusiveproperty.com", labelKey: null, label: "Premium property", vimeoId: "1184806917" },
  { url: "nathanretro.com", labelKey: null, label: "Creator portfolio", vimeoId: "1184806890" },
];

function Frame({ url, vimeoId }) {
  const src = `https://player.vimeo.com/video/${vimeoId}?background=1&autoplay=1&loop=1&muted=1&autopause=0&controls=0&playsinline=1`;
  return (
    <div className="relative rounded-xl overflow-hidden border border-black/20 bg-[#2a150a] group-hover:border-black/50 group-hover:-translate-y-1 group-hover:scale-[1.015] transition-all duration-500 shadow-[0_30px_60px_-25px_rgba(0,0,0,0.35)]">
      <div className="flex items-center gap-1.5 px-3 py-2 border-b border-white/10 bg-[#2a150a] relative z-10">
        <span className="w-2 h-2 rounded-full bg-[#ff5f57]" />
        <span className="w-2 h-2 rounded-full bg-[#febc2e]" />
        <span className="w-2 h-2 rounded-full bg-[#28c840]" />
        <div className="ml-3 flex-1 h-5 rounded bg-white/5 flex items-center justify-center">
          <span className="text-[10px] text-white/70 font-mono tracking-tight">{url}</span>
        </div>
      </div>
      <div className="relative aspect-video bg-black overflow-hidden">
        <iframe
          src={src}
          title={url}
          allow="autoplay; fullscreen"
          loading="lazy"
          frameBorder="0"
          className="absolute inset-0 w-full h-full pointer-events-none"
        />
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_rgba(0,0,0,0.25),_transparent_65%)]" />
        <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <div className="absolute inset-0 bg-black/10" />
          <div className="absolute top-3 right-3 w-10 h-10 rounded-full bg-white text-black grid place-items-center translate-y-1 group-hover:translate-y-0 transition-transform duration-500">
            <ArrowUpRight size={16} strokeWidth={2.5} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Portfolio() {
  const { t } = useApp();
  return (
    <section id="work" data-testid="portfolio-section" className="relative py-20 md:py-28">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-end justify-between gap-6 flex-wrap mb-12 md:mb-14">
            <div>
              {/* Phase 3I.4O.2 — collapse the duplicated eyebrow + title
                  into ONE canonical heading per spec. */}
              <h2
                data-testid="portfolio-heading"
                className="font-display font-black text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-black"
              >
                SELECTED WORK WE ADDED JUICE TO...
              </h2>
            </div>
            <p className="max-w-sm text-black/80 text-[15px] leading-relaxed">
              {t("work.sub")}
            </p>
          </div>
        </Reveal>

        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {projects.map((p, i) => (
            <StaggerItem key={p.url}>
              <a
                data-testid={`project-card-${i}`}
                href={`https://www.${p.url}`}
                target="_blank"
                rel="noreferrer"
                className="group block"
                aria-label={`${p.label} — open site in new tab`}
              >
                <Frame url={`www.${p.url}`} vimeoId={p.vimeoId} />
                <div className="flex items-center justify-between mt-4">
                  <span className="text-black text-[14px] font-display font-semibold tracking-tight">
                    {p.label}
                  </span>
                  <ArrowUpRight size={14} className="text-black/70 group-hover:text-black transition-colors" />
                </div>
              </a>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
